import { Info } from "@phosphor-icons/react";

export default function StatBlock({ label, value, unit, accent = "gold", hint, testid, tooltip }) {
  const colorMap = {
    gold: "text-gold",
    eco: "text-eco",
    sky: "text-sky2",
    risk: "text-risk",
    warn: "text-warn",
    white: "theme-ink",
  };
  return (
    <div
      data-testid={testid}
      className="relative group border theme-border theme-surface p-6 hover:border-gold/30 transition-colors"
    >
      <div className="overline flex items-center gap-1">
        {label}
        {tooltip && <Info size={10} weight="fill" className="theme-ink-dim group-hover:text-gold transition-colors" />}
      </div>
      <div className="mt-3 flex items-baseline gap-2">
        <div className={`font-mono-data text-3xl ${colorMap[accent]}`}>{value}</div>
        {unit && <div className="text-xs theme-ink-muted font-mono-data">{unit}</div>}
      </div>
      {hint && <div className="mt-2 text-xs theme-ink-muted">{hint}</div>}

      {tooltip && (
        <div className="invisible group-hover:visible absolute z-30 top-full left-0 mt-1 w-64 theme-surface border theme-border p-3 shadow-xl text-left">
          <div className="overline mb-1">How it&apos;s calculated</div>
          <div className="text-xs theme-ink-muted leading-relaxed">{tooltip}</div>
        </div>
      )}
    </div>
  );
}
